/* Ess-Nische theme.js (t1): essnische.formatMoney / announce / dialog / consent; <dialog>.showModal() = Fokusfalle.
   Vanilla ES2020, defer, keine Abhängigkeiten. Konfiguration aus window.essnische.config (layout/theme.liquid). */
(() => {
  const E = (window.essnische = window.essnische || {});
  const doc = document;

  // Geldbetrag in Cent im Shop-Format (z. B. „4,95 €“); Format aus essnische.config.moneyFormat
  E.formatMoney = (cents, format) => {
    const n = Number(String(cents).replace(/[^\d-]/g, '')) / 100;
    const fix = (d, t, s) => {
      const [i, f] = n.toFixed(d).split('.');
      return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (f ? s + f : '');
    };
    const map = {
      amount: [2, ',', '.'],
      amount_no_decimals: [0, ',', '.'],
      amount_with_comma_separator: [2, '.', ','],
      amount_no_decimals_with_comma_separator: [0, '.', ','],
      amount_with_space_separator: [2, ' ', ','],
      amount_with_period_and_space_separator: [2, ' ', '.'],
    };
    const fmt = format || (E.config && E.config.moneyFormat) || '{{amount_with_comma_separator}} €';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => fix(...(map[k] || map.amount_with_comma_separator)));
  };

  // Ansage für Screenreader in #A11yLive
  E.announce = (text) => {
    const r = doc.getElementById('A11yLive');
    if (!r) return;
    r.textContent = '';
    setTimeout(() => (r.textContent = text), 60);
  };

  const triggers = new WeakMap();
  const isDialog = (d) => d instanceof HTMLDialogElement;
  const expand = (d, v) =>
    d.id && doc.querySelectorAll(`[aria-controls="${d.id}"][aria-expanded]`).forEach((el) => el.setAttribute('aria-expanded', v));
  E.dialog = {
    open(d, trigger) {
      if (!isDialog(d) || d.open) return;
      triggers.set(d, trigger || doc.activeElement);
      d.showModal();
      expand(d, 'true');
      d.dispatchEvent(new CustomEvent('essnische:dialog:open', { bubbles: true }));
    },
    close(d) {
      if (isDialog(d) && d.open) d.close();
    },
  };
  // Fokus nach jedem Schließen (Escape, close(), Hintergrund) zurück zum Auslöser
  doc.addEventListener(
    'close',
    (e) => {
      const d = e.target;
      if (!isDialog(d)) return;
      expand(d, 'false');
      const t = triggers.get(d);
      triggers.delete(d);
      if (t && t.isConnected && t.focus) t.focus({ preventScroll: true });
    },
    true
  );

  const openMenus = () => doc.querySelectorAll('details[data-menu][open]');
  doc.addEventListener('click', (e) => {
    const t = e.target;
    const opener = t.closest('[data-dialog-open]');
    const closer = t.closest('[data-dialog-close]');
    if (opener) {
      const d = doc.getElementById(opener.dataset.dialogOpen);
      if (isDialog(d)) {
        e.preventDefault();
        E.dialog.open(d, opener);
      }
    } else if (closer) {
      e.preventDefault();
      E.dialog.close(closer.closest('dialog'));
    } else if (isDialog(t) && t.open && e.detail > 0) {
      const r = t.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) E.dialog.close(t);
    }
    openMenus().forEach((m) => !m.contains(t) && (m.open = false));
  });

  // Header-Aufklappmenüs: nur eines offen, Escape, Fokus verlassen, Hover mit Maus
  doc.addEventListener(
    'toggle',
    (e) => {
      const m = e.target;
      if (m.open && m.matches && m.matches('details[data-menu]')) openMenus().forEach((o) => o !== m && (o.open = false));
    },
    true
  );
  doc.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const m = (e.target.closest && e.target.closest('details[data-menu][open]')) || openMenus()[0];
    if (m) {
      m.open = false;
      m.querySelector('summary').focus();
    }
  });
  doc.addEventListener('focusout', (e) => {
    const m = e.target.closest && e.target.closest('details[data-menu][open]');
    if (m && e.relatedTarget && !m.contains(e.relatedTarget)) m.open = false;
  });
  if (matchMedia('(hover: hover) and (pointer: fine)').matches) {
    doc.querySelectorAll('details[data-menu]').forEach((m) => {
      let timer;
      const d = m.dataset;
      m.addEventListener('pointerenter', (e) => {
        if (e.pointerType !== 'mouse') return;
        clearTimeout(timer);
        if (!m.open) m.open = d.hover = '1';
      });
      m.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse' && d.hover) timer = setTimeout(() => (m.open = false), 200);
      });
      // Klick nach Hover-Öffnen: offen lassen
      m.firstElementChild.addEventListener('click', (e) => d.hover && m.open && (e.preventDefault(), delete d.hover));
      m.addEventListener('toggle', () => m.open || delete d.hover);
    });
  }

  // Consent (Shopify Customer Privacy API), kein eigener Banner (Pandectes).
  // Hook: essnische.consent.whenAllowed('analytics', fn) bzw. Event essnische:consent (detail: Zustand)
  const subs = [];
  const consent = (E.consent = {
    state: null,
    allowed: (type) => Boolean(consent.state && consent.state[type]),
    onChange: (cb) => (subs.push(cb), consent.state && cb(consent.state)),
    whenAllowed(type, cb) {
      let done;
      consent.onChange((s) => s[type] && !done && (done = true) && cb(s));
    },
    openPreferences: () => window.privacyBanner && window.privacyBanner.showPreferences && window.privacyBanner.showPreferences(),
  });
  const read = () => {
    const cp = window.Shopify && window.Shopify.customerPrivacy;
    if (!cp || !cp.analyticsProcessingAllowed) return;
    consent.state = {
      analytics: cp.analyticsProcessingAllowed(),
      marketing: cp.marketingAllowed(),
      preferences: cp.preferencesProcessingAllowed(),
      saleOfData: Boolean(cp.saleOfDataAllowed && cp.saleOfDataAllowed()),
    };
    subs.forEach((cb) => cb(consent.state));
    doc.dispatchEvent(new CustomEvent('essnische:consent', { detail: consent.state }));
  };
  doc.addEventListener('visitorConsentCollected', read);
  window.addEventListener('load', () => {
    const S = window.Shopify;
    if (S && S.loadFeatures) S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => err || read());
  });
})();
